/* eslint-disable max-len */
import React from "react"
import SearchEmptyScreen from "../../../../components/SearchEmptyScreen"
import TableTemplate from "../../../ManageMonitoringConditionsTemplates/Components/TableTemplate"
import CustomOverLay from "../../../../components/CustomOverLay"
import { useGetMonitorTemplatesQuery } from "../../../../features/monitorConditionTemplate"
import Emptyscreen from "../../../../components/EmptyScreen"
import { useEffect,useState,useRef,useContext } from "react"
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick"
import GlobalContext from "../../../../components/Context/GloablContext"

export default function ChooseMonitoringTemplateTable({edit,setChooseTemplate,patient_id,templateResult,templateTrigger,selectedRowIndex,setSelectedRowIndex,setTemplateId,addPatient}){
    const [totalPageNumber,setTotalPageNumber] = useState(1)
    const [queryParams, setQueryParams] = useState(`page_number=1&limit=15`);
    const {isSideBar} =useContext(GlobalContext)
    const [limit, setLimit] = useState(15);
    const [isOpen, setIsOpen] = useState(false);
    const {data,isFetching,isLoading,status} = useGetMonitorTemplatesQuery(queryParams)
    const [pageNumber, setPageNumber] = useState(1);

    const fetchPageAndLimit=()=>{
        const splitQuery = queryParams;
        const params = new URLSearchParams(splitQuery); 
        return params
    }
    const handlePageChange = (event) => {
        const value = event.target.value.replace(/[^0-9]/g, ''); // Replace non-numeric characters
        setPageNumber(value);
    };
    
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            let page = Number(pageNumber);
            // If the user enters 0 or a non-numeric value, redirect to the first page
            if (page < 1 || isNaN(page)) {
                page = 1;
            }
            // Update the input field to reflect the valid page number
            setPageNumber(page.toString());
    
            // Handle the page redirection for valid page numbers
            if (page >= 1 && page <= totalPageNumber) {
                handleOnClickPageNumber(page);
            } else if (page > totalPageNumber) {
                handleOnClickPageNumber(totalPageNumber);
            } else {
                // Handle invalid page numbers (should ideally not occur)
                const searchParams = fetchPageAndLimit();
                setPageNumber(parseInt(searchParams.get("page_number")) || 1);
            }
        }
    };

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit();
        setQueryParams(`page_number=${pageNum}&limit=${params.get("limit")}`);
    };

    const handlePrevClick = () => {
        const currentPage = parseInt(fetchPageAndLimit().get("page_number"));
        handleOnClickPageNumber(currentPage - 1);
    };

    const handleNextClick = () => {
        const currentPage = parseInt(fetchPageAndLimit().get("page_number"));
        handleOnClickPageNumber(currentPage + 1);
    };
    const limitArr = [15, 30, 50, 100];
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    // useOnClickOutside(ref, () => {
    //     setIsOpen(false);
    // });

    function handleNoOfRowsClick(number) {
        setQueryParams(`${`page_number=1&limit=${number}`}`);
    }

    const handlePaste = (event) => {
        event.preventDefault();
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        const params = fetchPageAndLimit();
        const calculatedTotalPages = calculateTotalPages(data?.total_count, parseInt(params.get("limit")));
        setTotalPageNumber(calculatedTotalPages);
        setPageNumber(parseInt(params.get("page_number")));
    }, [data, queryParams]);

    return(
        <div>
            <h1 className="text-[#000000] px-3 font-[400] text-[18px] pb-4">Choose template to associate with the patient</h1>
            {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Monitoring Conditions Templates list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay-list_patient_monitor':'overlay-list_patient_monitor'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                
                <div className="px-3">
                   
                    <TableTemplate
                        setPageNumber={setPageNumber}
                        queryParams={queryParams}
                        setTemplateId={setTemplateId}
                        List={data}
                        handleSearchParams={()=>{}}
                        setConfirmationState={()=>{}}
                        loading={false}
                        handleDelete={()=>{}}
                        selectedRowIndex={selectedRowIndex}
                        setSelectedRowIndex={setSelectedRowIndex}
                        setChooseTemplate={setChooseTemplate}
                        isPatientTemplateTable={true}
                        templateTrigger={templateTrigger}
                        templateResult={templateResult}
                        patient_id={patient_id}
                        edit={edit}
                    />
                </div>
                {data && data?.total_count>15 && 
                <div className="mx-3">
                    <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                        <p className="text-sm font-semibold text-[#687182]">
                            Total Number of Records: {data?.total_count}
                        </p>     
                        <div className="flex items-center">
                            <div className={`relative pl-1`}>
                                <button
                                    ref={buttonRef}
                                    onClick={() => setIsOpen(!isOpen)}
                                    type="button"
                                    className="text-sm font-semibold text-[#687182] flex items-center"
                                >
                                    <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                    <span className="pl-0.5">
                                        <img
                                            src="/images/down.svg"
                                            loading="lazy"
                                            decoding="async"
                                            className={`${isOpen ? "transform rotate-180" : ""}`}
                                            alt="icon"
                                            onClick={() => setIsOpen(!isOpen)}
                                        />
                                    </span>
                                </button>
                                <ul
                                    className={`absolute top-[-140px] left-[100px] pl-1.5 py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen ? "" : "hidden"}`}
                                    ref={dropdownRef}
                                >
                                    <li>
                                        <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                            {limitArr.map((item, index) => (
                                                <li key={index}>
                                                    <h1
                                                        onClick={() => {
                                                            setLimit(item);
                                                            setIsOpen(false);
                                                            handleNoOfRowsClick(item);
                                                        }}
                                                        className={`text-base font-normal cursor-pointer ${
                                                            item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                        } mb-[16px]`}
                                                    >
                                                        {item}
                                                    </h1>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="flex items-center ml-5">
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                    onClick={handlePrevClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/left.svg" alt="icon" loading="lazy" />
                                </button>
                                <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                    <input 
                                        type="number" 
                                        value={pageNumber} 
                                        onChange={handlePageChange} 
                                        onKeyPress={handleKeyPress} 
                                        min="1" 
                                        className="mx-2.5 px-1 py-[1px] border-2 border-[#687182] h-[25px] text-[#171C26] text-sm font-semibold rounded-md w-12 text-center"
                                        max={totalPageNumber}
                                        onPaste={handlePaste} // Prevent paste
                                    />
                                    <span className='pr-[10px] text-sm font-semibold text-[#687182]'> <span className='pr-[1px]'>/</span> {totalPageNumber}</span>
                                          
                                </p>
                                {/* <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                    <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                                </p> */}
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                    onClick={handleNextClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/right.svg" alt="icon" loading="lazy"/>
                                </button>
                            </div>
                        </div>
                    </div></div>}
            </>:<>
                { data?.total_count===0?<Emptyscreen
                    FirstPTag={"No Monitoring conditions template created yet "}
                    SecondePTag={"Click on ‘Create Template’ to create one"}
                    isPatientTemplate={true}
                />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                }
            </>}
         
        </div>
    )
}